var map = {
	"./Cardeck-is-full.svg": 869,
	"./carbon/add.svg": 5760,
	"./carbon/apps.svg": 3771,
	"./carbon/calendar.svg": 5697,
	"./carbon/checkbox-checked.svg": 1948,
	"./carbon/checkbox.svg": 4092,
	"./carbon/checkmark-outline.svg": 6563,
	"./carbon/chevron-down.svg": 7165,
	"./carbon/chevron-left.svg": 5734,
	"./carbon/chevron-right.svg": 1749,
	"./carbon/close.svg": 741,
	"./carbon/delivery-parcel.svg": 9015,
	"./carbon/edit.svg": 7895,
	"./carbon/empty.svg": 4766,
	"./carbon/events.svg": 7248,
	"./carbon/info.svg": 2155,
	"./carbon/information.svg": 7779,
	"./carbon/launch.svg": 5566,
	"./carbon/locked.svg": 2869,
	"./carbon/logout.svg": 7421,
	"./carbon/misuse-outline.svg": 9992,
	"./carbon/notification.svg": 1582,
	"./carbon/overflow-menu-vertical.svg": 1690,
	"./carbon/plug.svg": 1487,
	"./carbon/portfolio.svg": 6221,
	"./carbon/printer.svg": 6369,
	"./carbon/purchase.svg": 754,
	"./carbon/renew.svg": 3590,
	"./carbon/search.svg": 8815,
	"./carbon/send.svg": 5033,
	"./carbon/temperature-celsius.svg": 8056,
	"./carbon/traffic-event.svg": 9357,
	"./carbon/trash-can.svg": 5549,
	"./carbon/user-settings.svg": 8940,
	"./carbon/user.svg": 3010,
	"./carbon/van.svg": 7002,
	"./carbon/view.svg": 3284,
	"./carbon/warning-alt.svg": 3003,
	"./carbon/warning.svg": 2777,
	"./check-pink.svg": 5150,
	"./check-white.svg": 6049,
	"./checkmark.svg": 9558,
	"./close.svg": 3289,
	"./date.svg": 4251,
	"./dropdown-arrows.svg": 3167,
	"./error.svg": 9363,
	"./plus.svg": 4516,
	"./spinner.svg": 4346,
	"./switch.svg": 387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6116;